(function () {
  const tabHeaders = document.querySelectorAll('.product__tabHead');
  const overlapLinks = document.querySelectorAll('.product__tabsOverlayLink');
  const stickyWrapper = document.querySelector('.product__wrapper--sticky');
  const dropdowns = document.querySelectorAll('.product__dropdownTitle');

  function toggleTab(target) {
    if (target.classList.contains('product__tabHead--active')) {
      return false;
    }

    const activeTab = document.querySelector('.product__tabHead--active');
    const activeContent = document.querySelector('.product__tab--active');
    const currentContent = document.querySelector(`.product__tab[data-tab="${target.dataset.tab}"]`);

    activeTab.classList.remove('product__tabHead--active');
    activeContent.classList.remove('product__tab--active');

    target.classList.add('product__tabHead--active');
    currentContent.classList.add('product__tab--active');
  }

  function toggleContent() {
    const tabsArray = document.querySelectorAll('.product__tab');

    tabsArray.forEach((tab) => {
      const currentContent = tab.querySelector('.product__tabWrapper');
      const correntOverlay = tab.querySelector('.product__tabsDescriptionOverlay');
      const currentLink = tab.querySelector('.product__tabsOverlayLink');

      if (!currentLink.classList.contains('product__tabsOverlayLink--active')) {
        currentLink.classList.add('product__tabsOverlayLink--active');
        currentContent.classList.add('product__tabWrapper--active');
        correntOverlay.classList.add('product__tabsDescriptionOverlay--active');

        currentContent.style.maxHeight = `800px`;
        tab.style.maxHeight = `800px`;
      } else {
        currentLink.classList.remove('product__tabsOverlayLink--active');
        currentContent.classList.remove('product__tabWrapper--active');
        correntOverlay.classList.remove('product__tabsDescriptionOverlay--active');

        currentContent.style.maxHeight = `60px`;
        tab.style.maxHeight = `60px`;
      }
    });

    if (document.querySelector('.product__tabWrapper--active')) {
      stickyWrapper.classList.add('product__wrapper--stickyPadding');
    } else {
      stickyWrapper.classList.remove('product__wrapper--stickyPadding');
    }
  }

  function toggleDropdown(e) {
    const currentItem = e.currentTarget.closest('.product__dropdownItem');
    const currentContent = currentItem.querySelector('.product__dropdownItemContent');

    currentItem.classList.toggle('product__dropdownItem--active');

    if (currentItem.matches('.product__dropdownItem--active')) {
      currentContent.style.height = `${currentContent.scrollHeight}px`;
    } else {
      currentContent.style.height = '0px';
    }

    if (document.querySelector('.product__dropdownItem--active')) {
      stickyWrapper.classList.add('product__wrapper--stickyPadding');
    } else {
      stickyWrapper.classList.remove('product__wrapper--stickyPadding');
    }
  }

  tabHeaders.forEach((head) => {
    head.addEventListener('click', (e) => {
      toggleTab(e.currentTarget);
    });
  });

  overlapLinks.forEach((link) => {
    link.addEventListener('click', toggleContent);
  });

  dropdowns.forEach((dropdown) => {
    dropdown.addEventListener('click', toggleDropdown);
  });
}());
